export default {
    myProfile: 'Meu perfil',
    seeFullMap: 'Ver mapa completo',
    mapTitle: 'Mapa astral de <strong>{name}</strong>',
    myMapTitle: 'Meu <strong>mapa astral</strong>',
    oneFriend: '<strong>1</strong> amigo',
    friendsNumber: '<strong>{number}</strong> amigos',
    edit: 'Editar perfil',
    friends: 'Meus amigos',
    visitants: 'Visitantes Recentes',
    likes: 'Curtidas no perfil',

    actions: {
        sinastry: 'Sinastria',
        compatibility: 'Compatibilidade astral',
        like: 'Curtir',
        liked: 'Curtido',
        notFriends: 'Adicionar',
        sent: 'Enviado',
        friends: 'Amigo',
        received: 'Aceitar',
        removeFriendTitle: 'Excluir amigo',
        removeFriendContent:
      'Deseja realmente excluir esse usuário de sua lista de amigos?',
        blockUser: 'Bloquear usuário',
    },

    manageAccount: 'Gerenciar conta',

    myPurchases: {
        label: 'Minhas compras',
        link: 'assinatura',
    },
    privacy: 'Opções de Privacidade',

    about: {
        label: 'Sobre',
        link: 'sobre',
    },

    terms: {
        label: 'Termos de Uso',
        link: 'termos',
    },

    privacyPolitics: {
        label: 'Política de Privacidade',
        link: 'privacidade',
        title: 'Privacidade',
    },

    houseSystem: {
        label: 'Sistema de Casas',
        title: 'Sistema de Casas',
    },

    help: 'Central de ajuda',
    logout: 'Sair',
    alertBirthTime: 'Corrigir horário de Nascimento',
    alertAvatar: 'Adicione uma foto de perfil',
    noFriendsMine: 'Você ainda não possui nenhum amigo',
    noFriends: '{name} ainda não possui nenhum amigo',

    addPhotos: 'Incluir fotos',
    errorLoadingPhoto: 'Erro ao carregar a imagem',
    emptyGallery: 'Nenhuma foto enviada até o momento!',
    deletePhotoTitle: 'Excluir imagem',
    deletePhotoContent: 'Tem certeza que deseja excluir essa imagem?',

    errorFriends: 'Não foi possível carregar os amigos',
    errorGallery: 'Não foi possível carregar a galeria',
    blockUser: {
        successMessage: 'Usuário Bloqueado com sucesso',
        information:
      '<strong>Deseja mesmo bloquear {otherName}?</strong>Vocês não poderão mais ver informações um do outro. Para desbloqueá-lo, vá até suas preferências de privacidade.',
        confirmButton: 'Confirmar',
        cancelButton: 'Cancelar',
    },

    profileEdit: {
        link: 'my-profile',
        tabBirth: 'nascimento',
        tabPersonal: 'pessoal',
        tabAccount: 'conta',
        tabTerms: 'termos',
        help: 'https://suporte.astrolink.com.br/hc/pt-br',
        helpSSO: '/zendesk_login?return_to=https://suporte.astrolink.com.br/hc/pt-br'
    },

    contactUs: {
        title: 'Fale conosco',
        link: '/zendesk_login?return_to=https://suporte.astrolink.com.br/hc/pt-br/requests/new',
    }
};
